import { useEffect } from "react";
import { CustomerDetailingReportStore } from "../../store/main/CustomerDetailingReportStore";
import CustomerDetailingReportDesktop from "../components/desktop/customer-detailing-report/CustomerdetailingReportDesktop";
import { useMediaQuery, useTheme } from "@mui/material";
import CustomerDetailingReportMobile from "../components/mobile/customer-detailing-report/CustomerDetailingMobile";

const CustomerDetailingReport = () => {
  const { fetchCustomerDetailingReport } = CustomerDetailingReportStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    fetchCustomerDetailingReport();
  }, []);
  return (
    <>
      {isMobile ? (
        <CustomerDetailingReportMobile />
      ) : (
        <CustomerDetailingReportDesktop />
      )}
    </>
  );
};
export default CustomerDetailingReport;
